<template>
  <a-modal
      :title="title"
      :visible="visible"
      :width="1200"
      @ok="handleOk"
      @cancel="handleCancel">

    <a-form-model ref="targetForm" :model="form" :rules="rules" :label-col="{span: 5}" :wrapper-col="{span: 18}">
      <a-row class="form-row">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="姓名" prop="name">
            <a-input placeholder="请输入姓名" v-model.trim="form.name"/>
          </a-form-model-item>
        </a-col>
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="英文名称" prop="englishName">
            <a-input placeholder="请输入英文名称" v-model="form.englishName"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="性别" prop="sex">
            <a-select v-model="form.sex" placeholder="请输入性别">
              <a-select-option value="男">男</a-select-option>
              <a-select-option value="女">女</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="婚否" prop="married">
            <a-select v-model="form.married" placeholder="请输入婚否">
              <a-select-option value="是">是</a-select-option>
              <a-select-option value="否">否</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="签证类型" prop="type">
            <a-select v-model="form.type" placeholder="请输入签证类型">
              <a-select-option value="非劳务访问">非劳务访问</a-select-option>
<!--              <a-select-option value="非劳务访问-10年">非劳务访问-10年</a-select-option>-->
              <a-select-option value="劳务访问(无批文)">劳务访问(无批文)</a-select-option>
<!--              <a-select-option value="临时居留">临时居留</a-select-option>-->
              <a-select-option value="临时居留-学生">临时居留-学生</a-select-option>
              <a-select-option value="永久居留">永久居留</a-select-option>
              <a-select-option value="劳务访问(有批文)">劳务访问(有批文)</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="领区" prop="area">
            <a-select v-model="form.area" placeholder="请输入领区">
              <a-select-option value="BEIJING">BEIJING(北京)</a-select-option>
              <a-select-option value="SHANGHAI">SHANGHAI(上海)</a-select-option>
              <a-select-option value="GUANGZHOU">GUANGZHOU(广州)</a-select-option>
<!--              <a-select-option value="SINGAPORE">SINGAPORE(新加坡)</a-select-option>-->
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="出生日期" prop="birthday">
            <a-date-picker style="width: 100%" v-model="form.birthday" valueFormat="YYYY-MM-DD"/>
          </a-form-model-item>
        </a-col>

        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="电话" prop="phone">
            <a-input placeholder="请输入电话" v-model.trim="form.phone"/>
          </a-form-model-item>
        </a-col>

      </a-row>
      <a-row class="form-row" v-if="form.type === '劳务访问(有批文)'">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="护照" prop="passport">
            <a-input placeholder="请输入护照" v-model.trim="form.passport"/>
          </a-form-model-item>
        </a-col>
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="批文" prop="unt">
            <a-input placeholder="请输入批文" v-model.trim="form.unt"/>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row class="form-row">
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="预约日期范围" prop="applicantDate">
            <a-range-picker style="width: 100%" valueFormat="YYYY-MM-DD" v-model="form.applicantDate"/>
          </a-form-model-item>
        </a-col>
        <a-col :lg="12" :md="12" :sm="12">
          <a-form-model-item label="备注" prop="remark">
            <a-input placeholder="请输入备注" v-model.trim="form.remark"/>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>

  </a-modal>

</template>

<script>

import moment from 'moment'
import {HttpMixins} from "@/mixins/http-mixins";

const pattern = {
  name: /^([\u4E00-\u9FA5\w ]+)$/,
  passport: /^([A-Z0-9]+)$/,
  unt: /^(\d{7})$/,
  phone: /^(1[345789]\d{9})$/,
}

export default {
  name: "CreateModal",
  mixins: [HttpMixins],
  data() {
    return {
      title: '',
      visible: false,
      form: {},
      rules: {
        name: [
          {required: true, pattern: pattern.name, message: '请输入姓名!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'},
        ],
        englishName: [
          {required: true, pattern: pattern.name, message: '请输入英文姓名!'},
          {min: 0, max: 256, message: '长度不超过 256 个字符', trigger: 'blur'},
        ],
        sex: [
          {required: true, message: '请选择性别!'},
        ],
        married: [
          {required: true, message: '请现在婚否!'},
        ],
        type: [
          {required: true, message: '请输入签证类型!'},
        ],
        area: [
          {required: true, message: '请输入签证领区!'},
        ],
        birthday: [
          {required: true, message: '请输入出生日期!'},
        ],
        passport: [
          {required: true, pattern: pattern.passport, message: '请输入护照号!'},
        ],
        unt: [
          {required: true, pattern: pattern.unt, message: '请输入批文!'},
        ],
        phone: [
          {required: true, pattern: pattern.phone, message: '请输入电话!'},
        ],
        applicantDate: [
          {required: true, message: '请输入预约开始日期!'},
        ],
        remark: [],

      },
      url: {
        add: window._CONFIG['domainURL'] + "/mxApplicant",
        edit: window._CONFIG['domainURL'] + "/mxApplicant",
      }
    }
  },
  methods: {
    moment,
    show(record) {
      this.visible = true;

      this.$nextTick(() => {
        this.$refs.targetForm.resetFields();
        if (record) {
          this.title = '编辑';
          let data = Object.assign({}, record);
          data.applicantDate = [record.applicantStart, record.applicantEnd]
          this.form = Object.assign({}, data);
        } else {
          this.title = '新增';
          this.form = {};
        }
      })
    },
    handleOk() {
      let that = this;
      this.$refs.targetForm.validate(valid => {
        if (valid) {
          if (that.form.applicantDate) {
            that.form.applicantStart = that.form.applicantDate[0];
            that.form.applicantEnd = that.form.applicantDate[1];
            that.form.authority = localStorage.getItem('username');
            that.form.user = localStorage.getItem('username');
          }
          if (that.title === '新增') {
            that.$axios.post(that.url.add, that.form, {headers: that.headers}).then((res) => {
              let response = res.data;
              if (response.code === 200) {
                that.$message.success(response.msg);
                that.$emit('ok');
                that.handleCancel();
              } else {
                that.$message.error(response.msg);
              }
            }).catch((error) => {
              that.catchError(error);
            })
          }
          if (that.title === '编辑') {
            that.$axios.put(that.url.edit, that.form, {headers: that.headers}).then((res) => {
              let response = res.data;
              if (response.code === 200) {
                that.$message.success(response.msg);
                that.$emit('ok');
                that.handleCancel();
              } else {
                that.$message.error(response.msg);
              }
            }).catch((error) => {
              that.catchError(error);
            })
          }
        }
      });
    },
    handleCancel() {
      this.visible = false;
    },
    filterSpecial(rule, value, callback) {
      const pattern = new RegExp("[.`~!@#$^&*=|{}':;',\\[\\]<>《》/?~！@#￥……&*|{}【】‘；：”“'。，、？'']");
      if (pattern.test(value)) {
        callback('禁止输入特殊字符')
      } else {
        callback()
      }
    }
  }
}
</script>

<style scoped>

</style>
